<template>
  <div id="topic-container" v-show="isTopicViewActiveLocal" ref="topic_view">
    <div class="vx-row limit-width_fixed-scalable" >
      <div class="vx-col mb-3" vs-lg="4" style="margin-top:8px">
        <span style="font-size: 18pt;font-weight: 100;color:white;">
          You have selected:
        </span>
      </div>

      <div class="vx-col" vs-lg="4" style="margin:auto">
        <vx-card v-if="!isStudent" class="glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickLanguage">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedLanguage }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card v-if="!isStudent"  class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickGrade">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedGrade.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <img height="25" :src="selectedSubject.icon" />
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickSubject">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedSubject.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
        <vx-card class="mt-3 glow-effect_dark limit-width_fixed card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg">
                <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                        class="w-full button-text__left-align glow-effect_primary__hover back-button bg-color"
                        style="border-radius:0 7px 7px 0"
                        type="filled"
                        color=""
                        @click="backToPickModule">
              <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
              {{ selectedModule.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>

    <div class="mt-4 w-full">
      <ul style="flex-wrap: wrap;">
        <div class="limit-width_fixed-scalable" style="text-align: left;">
          <li>
            <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 400px">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_bg-color__blend bg-color">
                    <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                  type="filled"
                  color="">
                  Select a Topic in a Term
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        
          <li v-for="(_term, termIndex) in terms" :key="termIndex" class="mb-3 mr-3">
            <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" >
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_bg-color__blend bg-color">
                    <span><feather-icon class="pt-1" icon="ClockIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  :disabled="true"
                  size="large"
                  class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-term bg-color"
                  style="border-radius:0 7px 7px 0; width:100%"
                  type="filled"
                  color="">
                  {{ _term.name }}
                </vs-button>
              </vx-input-group>
            </vx-card>

            <ul style="margin-top: 0.2rem;margin-bottom: 1.2rem;flex-wrap: wrap;">
              <li v-for="(_topic, topicIndex) in topics.filter(function(item){return item.termId == _term.id}).sort((x,y) => x.number - y.number)" :key="topicIndex" class="mb-3">
                <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
                  <vx-input-group>
                    <template slot="prepend">
                      <vs-button v-if="_topic.hasNewContent" :disabled="true" id="new-content" size="small" radius color="#4e5c9a" type="filled" icon-pack="feather" icon="icon-star" class="button__fully-opaque glow-effect_light"></vs-button>
                      <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                        <span><feather-icon class="pt-1" icon="DiscIcon" svg-classes="stroke-current"></feather-icon></span>
                      </div>
                    </template>

                    <vs-button
                      size="large"
                      class="w-full glow-effect_primary button-text__left-align school-primary_gradient"
                      style="border-radius:0 7px 7px 0;"
                      @click="selectTopic(_topic)">
                      {{ _topic.name }}
                    </vs-button>
                    <span id="schedule_btn-container" v-if="!isStudent && _topic.siteId != $getSiteId()">
                      <feather-icon
                        v-if="_topic.scheduleId && !isTeacher"
                        id="schedule_btn"
                        class="p-2"
                        icon="CheckIcon" 
                        svg-classes="stroke-current"
                        @click.stop.prevent="openSchedulePopup(_topic)"
                      />
                      <feather-icon
                        v-else
                        id="schedule_btn"
                        class="p-2"
                        icon="CalendarIcon" 
                        svg-classes="stroke-current"
                        @click.stop.prevent="openSchedulePopup(_topic)"
                      />
                    </span>

                    <span id="manage-topic-fab" v-else-if="!isStudent && _topic.siteId == $getSiteId()">
                      <div class="fab_manage-topic">
                        <div class="float-btn-group">
                          <button :id="`topic-${_topic.id}`" class="btn-float btn-triger input-group_prepend-slot-bg" @click="openActions">
                            <i class="icon feather icon-more-horizontal text-white" />
                          </button>
                          <div class="btn-list">
                            <a v-if="isTeacher && topicIndex" class="btn-float dc_dark-purple description glow-effect_dark" @click="MoveTopicUp(_topic.id,_term.id)">
                              <i class="icon feather icon-arrow-up" />
                            </a>
                            <a v-if="isTeacher && !topicIndex" class="btn-float dc_dark-purple description glow-effect_dark pe-none">
                            </a>
                            <a v-if="_topic.scheduleId && !isTeacher" class="btn-float dc_dark-purple description glow-effect_dark" @click="openSchedulePopup(_topic)">
                              <i class="icon feather icon-check text-white"></i>
                            </a>
                            <a v-else class="btn-float dc_dark-purple description glow-effect_dark" @click="openSchedulePopup(_topic)">
                              <i class="icon feather icon-calendar text-white"></i>
                            </a>
                            <a v-if="isTeacher" class="btn-float dc_dark-purple description glow-effect_dark" @click="editTopic(_topic)">
                              <i class="icon feather icon-edit text-white" />
                            </a>
                            <a v-if="isTeacher && _topic != topics.filter(function(item){return item.termId == _term.id})[topics.filter(function(item){return item.termId == _term.id}).length - 1]" class="btn-float dc_dark-purple description glow-effect_dark" @click="MoveTopicDown(_topic.id,_term.id)">
                              <i class="icon feather icon-arrow-down" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </span>
                  </vx-input-group>
                </vx-card>
              </li>
              <p v-show="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">Watch this space! Content coming soon...</p>
            </ul>
          </li>
          <li>            
            <vx-card v-show="!isStudent" class="glow-effect_dark limit-height_content-height limit-width_fixed-scalable card__no-padding bg-color">
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text glow-effect_primary limit-height_content-height school-primary_gradient" style="width: 70px;">
                    <span><feather-icon class="pt-1 ml-3" icon="PlusIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template>

                <vs-button
                  id="add-standalone-content-btn"
                  size="large"
                  class="w-full button__fully-opaque glow-effect_primary limit-height_content-height button-text__left-align input-group_prepend-slot-bg"
                  style="border-radius:0 7px 7px 0;"
                  color=""
                  @click="showAddTopicPopup">
                  Add a Topic
                </vs-button>
              </vx-input-group>
            </vx-card>
          </li>
        </div>
      </ul>
    </div>

    <vs-popup id="schedule-popup" title="Set a Schedule" :active.sync="schedulePopupActive">
      <div class="vx-row mx-auto">
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full">
          <h3 class="text__school-font-color text-center mb-3">VISIBLE FROM</h3>
          <datepicker ref="fromPicker" v-model="scheduleData.fromDate" :inline="true" :format="format" :highlighted="highlightedFn"></datepicker>
        </div>
        <div class="vx-col xl:w-1/2 lg:w-1/2 md:w-full sm:w-full xs:w-full">
          <h3 class="text__school-font-color text-center mb-3">COMPLETED BY</h3>
          <datepicker ref="toPicker" v-model="scheduleData.toDate" :inline="true" :format="format"></datepicker>
        </div>
      </div>
      <div v-if="scheduleData.classrooms.length > 0" v-show="virtualClassroom()" class="vx-row mt-4 mb-5">
        <div class="vx-col w-full">
          <vs-table class="vs-con-loading__container" stripe single pagination max-items="7" :data="scheduleData.classrooms">

            <template slot="thead">
              <vs-th>Classroom</vs-th>
              <vs-th>Schedule</vs-th>
              <vs-th>Apply To</vs-th>
            </template>

            <template slot-scope="{data}">

              <vs-tr :data="classroom" :key="index" v-for="(classroom, index) in data">

                <vs-td>
                  {{ classroom.name }}
                </vs-td>

                <vs-td>
                  <p v-if="classroom.fromDate">{{ classroom.fromDate.split('T')[0] }}<small><strong>&nbsp;&nbsp;TO&nbsp;&nbsp;</strong></small>{{ classroom.toDate.split('T')[0] }}</p>
                  <p v-else><strong>No Schedule</strong></p>
                </vs-td>

                <vs-td>
                  <vs-checkbox v-model="classroom.selected" />
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div v-else v-show="virtualClassroom()" >
        <p  style="color:white;font-weight:500;font-size:16px;padding-top:5px;text-align:center;">Please add a classroom first</p>
      </div>

      <div class="vx-row mx-auto mt-4">
        <div class="vx-col">
          <vs-button
            :disabled="isRemoveDisabled"
            ref="remove_btn"
            size="small"
            class="text-white glow-effect_green vs-con-loading__container"
            type="gradient"
            color="#52b75d"
            gradient-color-secondary="#88c45c"
            @click.stop.prevent="removeSchedule">
            REMOVE
          </vs-button>
        </div>
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            :disabled="isSaveDisabled "
            ref="save_btn"
            size="small"
            class="text-white glow-effect_green vs-con-loading__container"
            type="gradient"
            color="#52b75d"
            gradient-color-secondary="#88c45c"
            @click.stop.prevent="saveSchedule">
            SAVE
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup id="topic-popup" :title=" !editTopicActive ? 'Create Topic' : 'Edit Topic'" width="400px" :active.sync="topicPopupActive">
      <div class="vx-row mx-auto">
        <div class="vx-col w-full">
          <p>Course</p>
          <vs-input :disabled="true" class="w-full" v-model="selectedSubject.name" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Module</p>
          <vs-input :disabled="true" class="w-full" v-model="selectedModule.name" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Term</p>
          <v-select 
            ref="termDropdown"
            class="w-full style-chooser"
            placeholder="Select a Term"
            :options="termsList"
            v-model="termDropdown"
          />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Name</p>
          <vs-input class="w-full" v-model="topicData.name" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Description</p>
          <vs-input class="w-full" v-model="topicData.description" />
        </div>
      </div>
      <div class="vx-row mx-auto mt-3">
        <div class="vx-col w-full">
          <p>Curriculum Configuration</p>
          <div class="centex mb-3 mt-1">
            <vs-switch v-model="topicData.forTrimmedDownCurriculum" color="success" id="vsswitch">
              <span slot="off">Normal</span>
              <span slot="on">Stripped-Down</span>
            </vs-switch>
          </div>
        </div>
      </div>
      
      <div class="vx-row mx-auto mt-4">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button
            :disabled="saveTopicDisabled"
            ref="save_btn"
            size="small"
            class="text-white vs-con-loading__container"
            type="filled"
            color="success"
            @click.stop.prevent="saveTopic">
            Save
          </vs-button>
        </div>
        <div class="vx-col" v-if="editTopicActive">
          <vs-button
            size="small"
            class="vs-con-loading__container"
            type="border"
            color="danger"
            @click.stop.prevent="deleteTopicValidation(selectedTopic)">
            Delete
          </vs-button>
        </div>
        <div class="vx-col">
          <vs-button
            size="small"
            class="vs-con-loading__container"
            type="border"
            color="warning"
            @click.stop.prevent="cancleTopicEdit()">
            Cancel
          </vs-button>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
export default {
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      terms: [],
      topics: [],
      showComingSoon: false,
      schedulePopupActive: false,
      scheduleId: null,
      scheduleData: {
        moduleId: null,
        fromDate: null,
        toDate: null,
        classrooms: []
      },
      format: "yyyy-MM-dd",
      highlightedFn: {
        customPredictor(date) {
          var today = new Date();
          
          if (date.getDate() == today.getDate() && date.getMonth() == today.getMonth()) {
            return true;
          }
        }
      },
      topicPopupActive: false,
      topicData: {
        id: 0,
        name: "",
        description: "",
        courseId: null,
        moduleCategoryId: null, //selectedModule
        moduleGroupId: null, //terms
        forTrimmedDownCurriculum: false,
        isPremium:false,
      },
      termsList: [],
      termDropdown: 0,
      fabElement: null,
      selectedTopic:{},
      editTopicActive:false,
      selectedElement:"",
    };
  },
  props: {
    isTopicViewActive: {
      required: false,
    },
    isStudent: {
      type: Boolean,
      required: false
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      type: Object,
      required: false
    },
    selectedSubject: {
      type: Object,
      required: true
    },
    selectedModule: {
      type: Object,
      required: true
    },
    moduleData: {
      type: Array,
      required: false
    },
    isTeacher: {
      type: Boolean,
      required: false
    },
  },
  watch: {
    isTopicViewActive: function(val) {
      if(val){
        var self = this;
        if(self.moduleData)
          self.getTermsAndTopics();
      }
    },
    schedulePopupActive: function(val) {
      if(!val) {
        this.initScheduleValues();
      }
      else {
        if (this.isTeacher) {
          this.getScheduleDataTeacher();
        }
        else {
          this.getScheduleDataAdmin();
        }
      }
    },
    topicPopupActive: function(val) {
      if(!val) {
        this.initTopicValues();
      }
    }
  },
  computed: {
    isTopicViewActiveLocal: {
      get() {
        return this.isTopicViewActive;
      }
    },
    isRemoveDisabled: function() {
      var isAtLeastOneClassSelected = this.scheduleData.classrooms.filter(function(item) { return item.selected; }).length > 0;

      return !isAtLeastOneClassSelected && this.isTeacher;
    },
    isSaveDisabled: function() {
      var isDateSelected = this.scheduleData.fromDate && this.scheduleData.toDate ? true : false;
      if(this.virtualClassroom()){
        var isAtLeastOneClassSelected = this.scheduleData.classrooms.filter(function(item) { return item.selected; }).length > 0;
        return !isDateSelected || (!isAtLeastOneClassSelected && this.isTeacher);
      }
      else{
        return !isDateSelected && this.isTeacher;
      }
      

      
    },
    saveTopicDisabled: function() {
      var topicHasName = this.topicData.name ? true : false;
      var topicHasDesc = this.topicData.description ? true : false;
      var termSelected = this.termDropdown && this.termDropdown.value ? true : false;

      return !topicHasName || !topicHasDesc || !termSelected;
    }
  },
  methods: {
    initValues() {
      this.terms = [];
      this.topics = [];
      this.initScheduleValues();
      this.editTopicActive = false;
    },
    initScheduleValues() {
      this.scheduleId = null;
      this.scheduleData.fromDate = null;
      this.scheduleData.toDate = null;
      this.scheduleData.classrooms = [];
      this.$vs.loading.close(this.$refs.save_btn.$el);
      this.$vs.loading.close(this.$refs.remove_btn.$el);
    },
    getTermsAndTopics() {
      var self = this;
      self.showComingSoon = false;

      self.initValues();

      var temp_terms = [];
      temp_terms = self.moduleData.map(function(item) {
        return { id: item.moduleGroupId, name: item.moduleGroupName };
      });

      self.topics = self.moduleData.map(function(item) {
        return {
          id: item.id,
          name: item.name,
          number : item.moduleNumber,
          description: item.description,
          moduleId: item.moduleCategoryId,
          termId: item.moduleGroupId,
          startTaskDisplayId: item.startTaskDisplayId,
          hasNewContent: item.hasNewContent,
          structuredLessonAvailable: item.structuredLessonAvailable,
          structuredLessonEditable: item.structuredLessonEditable,
          scheduleId: item.scheduleId,
          scheduleFromDate: item.scheduleFromDate,
          scheduleToDate: item.scheduleToDate,
          siteId: item.siteId,
          forTrimmedDownCurriculum: item.forTrimmedDownCurriculum,
          isPremium: item.isPremium,
        };
      }).filter(function(item){ return item.moduleId == self.selectedModule.id }).sort((a, b) => a.number - b.number);
      
      temp_terms.filter(function(item) {
        return self.topics.map(function(_topic) {
          return _topic.termId; 
        }).includes(item.id);
      }).forEach(_term => {
        if (self.terms.filter(function(item) {
          return _term.id == item.id
        }).length == 0 && _term.id != null)
          self.terms.push(_term);
      });
      self.terms = self.terms.sort((a, b) => a.name > b.name ? 1 : -1); 
    },

    selectTopic(topic) {
      var self = this;
      self.$emit("topicSelected", topic);
    },
    backToPickLanguage() {
      this.initValues();
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.initValues();
      this.$emit("backToPickGrade");
    },
    backToPickSubject() {
      this.initValues();
      this.$emit("backToPickSubject");
    },
    backToPickModule() {
      this.initValues();
      this.$emit("backToPickModule");
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    virtualClassroom(){
      if(JSON.parse(localStorage.getItem('userSiteInfo')) instanceof Array)
        return JSON.parse(localStorage.getItem('userSiteInfo'))[0].virtualClassroom;
      else 
        return JSON.parse(localStorage.getItem('userSiteInfo')).virtualClassroom;
    },
    getScheduleDataAdmin() {
      var self = this;

      self.showLoadingOnElement('topic_view', 1, 'material');

      var onSuccess = function(response) {
        if(response.data) {
          self.scheduleId = response.data.scheduleId;
          self.scheduleData.moduleId = response.data.moduleId;
          self.scheduleData.fromDate = response.data.fromDate;
          self.scheduleData.toDate = response.data.toDate;
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.topic_view.$el);
      };

      self.$ajaxGet(self, "Schedule/GetScheduleAdmin/" + self.scheduleData.moduleId, onSuccess, onFinally);
    },
    getScheduleDataTeacher() {
      var self = this;

      self.showLoadingOnElement('topic_view', 1, 'material');

      var onSuccess = function(response) {
        if(response.data) {
          self.scheduleId = response.data.scheduleId;
          self.scheduleData.moduleId = response.data.moduleId;
          self.scheduleData.classrooms = response.data.classrooms;
        }
      };

      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.topic_view.$el);
      };

      self.$ajaxGet(self, "Schedule/GetScheduleTeacher/" + self.scheduleData.moduleId, onSuccess, onFinally);
    },
    openSchedulePopup(topic) {
      var self = this;
      self.closeActions();
      self.scheduleData.moduleId = topic.id;
      self.schedulePopupActive = true;
    },
    saveSchedule() {
      var self = this;

      self.scheduleData.fromDate = self.$formatDate(self.scheduleData.fromDate);
      self.scheduleData.toDate = self.$formatDate(self.scheduleData.toDate);

      if (self.scheduleData.classrooms.length > 0) {
        var selectedClassrooms = self.scheduleData.classrooms.filter(function(item) {return item.selected});
        selectedClassrooms.forEach(function(item) {
          item.fromDate = self.scheduleData.fromDate;
          item.toDate = self.scheduleData.toDate;
        })
      }

      self.showLoadingOnElement('save_btn', 0.35, 'material');

      var onSuccess = function(response) {
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Schedule(s) saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-check'
        });

        self.schedulePopupActive = false;

        if (response.data != 0)
          self.topics.filter(function(item) {return item.id == self.scheduleData.moduleId})[0].scheduleId = response.data;
      };

      var onFinally = function(response) {
        if(self.schedulePopupActive)
          self.$vs.loading.close(self.$refs.save_btn.$el);
      };

      self.$ajaxPost(self, "Schedule/Save", self.scheduleData, onSuccess, onFinally);
    },
    removeSchedule() {
      var self = this;

      self.showLoadingOnElement('remove_btn', 0.35, 'material');

      if (self.isTeacher) {
        var selectedClassrooms = self.scheduleData.classrooms.filter(function(item) {return item.selected});
        selectedClassrooms = selectedClassrooms.map(function(item) {return item.id});

        var deleteData = {
          classroomIds: selectedClassrooms,
          moduleId: self.scheduleData.moduleId
        }

        var onTSuccess = function(response) {
          self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Schedule(s) removed",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-x'
          });
          self.schedulePopupActive = false;
          self.scheduleData.fromDate = null;
          self.scheduleData.toDate = null;
        };

        var onTFinally = function(response) {
          if(self.schedulePopupActive)
            self.$vs.loading.close(self.$refs.remove_btn.$el);
        };

        self.$ajaxPost(self, "Schedule/Remove", deleteData, onTSuccess, onTFinally);
      }
      else {
        var onASuccess = function(response) {
          self.scheduleData.fromDate = null;
          self.scheduleData.toDate = null;
          self.topics.filter(function(item) {return item.id == self.scheduleData.moduleId})[0].scheduleId = null;
        };

        var onAFinally = function(response) {
          if(self.schedulePopupActive)
            self.$vs.loading.close(self.$refs.remove_btn.$el);
        };

        self.$ajaxGet(self, "Schedule/Remove/" + self.scheduleData.moduleId, onASuccess, onAFinally);
      }
    },
    initTopicValues() {
      var self = this;
      this.topicData.id = 0;
      this.topicData.name = "";
      this.topicData.description = "";
      this.topicData.forTrimmedDownCurriculum = false;
      this.topicData.courseId = null;
      this.topicData.moduleCategoryId = null;
      this.topicData.moduleGroupId = null;
      this.termDropdown = 0;
      
      var onSuccess = response => {
         self.termsList = response.data.map((item) => { return { label: item.name, value: item.id } });
       };

      self.termsList = self.$ajaxGet(self, "ModuleGroup/ListModuleGroups", onSuccess);  
    },
    showAddTopicPopup() {
      var self = this;
      self.initTopicValues();
      self.topicPopupActive = true;
    },
    saveTopic() {
      var self = this;

      self.showLoadingOnElement('save_btn', 0.35, 'material');

      self.topicData.courseId = self.selectedSubject.id;
      self.topicData.moduleCategoryId = self.selectedModule.id;
      self.topicData.moduleGroupId = self.termDropdown ? parseInt(self.termDropdown.value) : null;
      var highestNumber = Math.max(...self.topics.map(function(x) { return x.number }));
      self.topicData.number = highestNumber > 0 ? highestNumber + 1 : 0;

      var onSuccess = function(response) {
        self.topicData.id = response.data.id;

        self.$emit("topicAdded", self.selectedSubject, self.selectedSubject.icon, function() {
          self.getTermsAndTopics();
          self.backToPickModule();
        }, true);
        
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Topic saved",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-check'
        });

        self.topicPopupActive = false;
      };

      self.$ajaxPost(self, "Module/AddEditModule", self.topicData, onSuccess);
    },
    editTopic(topic) {
      var self = this;
      self.editTopicActive = true;
      self.closeActions();
      self.selectedTopic = topic;
      self.topicData.id = topic.id;
      self.topicData.name = topic.name;
      self.topicData.description = topic.description;
      self.topicData.forTrimmedDownCurriculum = topic.forTrimmedDownCurriculum;
      self.topicData.courseId = self.selectedSubject.id;
      self.topicData.moduleCategoryId = topic.moduleId;
      self.topicData.moduleGroupId = topic.termId;
      self.topicData.isPremium = topic.isPremium;
      self.termDropdown = self.termsList.filter(function (item) { return item.value == topic.termId; })[0];
      self.topicPopupActive = true;
    },
    deleteTopicValidation(topic){
      var self = this;
      self.$swal({
        title: 'Are you sure you want to delete' + " " + '<strong>' + topic.name + '</strong>',
        icon: 'error',
        showCancelButton: true,
        cancelButtonText: `Cancel`,
        confirmButtonText: 'Yes Delete',
        confirmButtonColor: '#d33',
      }).then((result) => {
        if (result.isConfirmed) {
          self.deleteTopic(topic.id);
        }
      });
    },
    deleteTopic(topicId) {
      var self = this;
      self.closeActions();

      self.showLoadingOnElement('topic_view', 1, 'material');

      var onSuccess = function(response) {
        self.$emit("topicRemoved", self.selectedSubject, self.selectedSubject.icon, function() {
          self.getTermsAndTopics();
          self.backToPickModule();
        }, true);
        self.topicPopupActive = false;
        self.editTopicActive = false;
      };

      var onFinally = function(response) {
        if(self.topicPopupActive)
          self.$vs.loading.close(self.$refs.topic_view.$el);
        self.$swal.fire('Topic Removed', '', 'error');
      };

      self.$ajaxGet(self, "Module/DeleteModule/" + topicId, onSuccess, onFinally);
    },
    
    closebtnGroups(){
      var self = this;
      var openBtnGroups = [];
      openBtnGroups = document.getElementsByClassName('float-btn-group open');
      openBtnGroups.forEach(element => {
        element.classList.remove("open");
      });
    },
    openActions(e) {
      this.closebtnGroups();
      this.fabElement= e.target.closest(".float-btn-group");

      if(!this.selectedElement || this.selectedElement != this.fabElement.firstChild.id){
        this.fabElement.classList.add('open')
        this.selectedElement = this.fabElement.firstChild.id;
      }
      else if(this.selectedElement == this.fabElement.firstChild.id){
        this.fabElement.classList.remove('open');
        this.selectedElement = "";
      }
      
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
        this.selectedElement = "";
    },
    cancleTopicEdit(){
      this.topicPopupActive = false;
      this.editTopicActive=false;
    },
    MoveTopicUp(topicId,termId){
      var self = this;
      var topicList = this.topics.filter(function(item){return item.termId == termId});
      var swapModuleId = topicList[topicList.findIndex(x=>x.id == topicId) - 1].id;

      var onSuccess = response =>{
        self.closeActions();
        self.$emit("subjectSelectedReload", self.selectedSubject, self.selectedSubject.icon);

      }
      var onFinally = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order change saved`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
      self.$ajaxGet(self, `Module/MoveModule?moduleId=${topicId}&swapmoduleId=${swapModuleId}`  , onSuccess, onFinally);
    },
    MoveTopicDown(topicId,termId){
      var self = this;
      var topicList = this.topics.filter(function(item){return item.termId == termId});
      var swapModuleId = topicList[topicList.findIndex(x=>x.id == topicId) + 1].id;
      var onSuccess = response =>{
        self.closeActions();
        self.$emit("subjectSelectedReload", self.selectedSubject, self.selectedSubject.icon);
      }
      var onFinally = response =>{
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order change saved`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      }
      self.$ajaxGet(self, `Module/MoveModule?moduleId=${swapModuleId}&swapmoduleId=${topicId}`  , onSuccess, onFinally);
    }
  },
  mounted(){
    var self = this;   
    self.getTermsAndTopics();      
  }

};
</script>
<style lang="scss">
  #vsswitch {
    background: #28C76F !important;
    width: 110px !important;
    .vs-switch--text {
      color: #ffffff !important;
    }
  }
  #topic-container{
    .btn-float:nth-child(4){
      bottom: 6px !important;
      left: 0 !important;
      right: 0 !important;
    }
    .pe-none{
      pointer-events: none;
      cursor: default;
    }
  }
</style>